import React from 'react';
import { motion } from 'framer-motion';
export const CHECKOUT_URL = 'https://ventosas-pro.impultienda.ar/checkout/mega-pack-ventosas';
type SectionProps = {
  children: React.ReactNode;
  className?: string;
  id?: string;
  glow?: boolean;
};
export function Section({
  children,
  className = '',
  id = '',
  glow = false
}: SectionProps) {
  return <motion.section id={id} initial={{
    opacity: 0,
    y: 24
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.55
  }} className={`relative mx-auto w-full max-w-7xl px-4 py-12 sm:px-6 md:py-20 lg:px-8 ${className}`} data-id="element-273" data-mp="1878g5uhq7ble">
      {glow && <div aria-hidden="true" className="pointer-events-none absolute inset-0 -z-10 overflow-hidden" data-id="element-274" data-mp="khxmsy2pgjha">
          <div className="animate-aurora-1 absolute -top-16 left-[15%] h-80 w-80 rounded-full bg-brand-greenSage blur-[100px]" data-id="element-275" data-mp="1vuqe67rl35wt" />
          <div className="animate-aurora-2 absolute -bottom-12 right-[12%] h-72 w-72 rounded-full bg-brand-goldLight/50 blur-[110px]" data-id="element-276" data-mp="20t1o0ihvpgf1" />
        </div>}
      {children}
    </motion.section>;
}
type CTAButtonProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
  fullWidth?: boolean;
  variant?: 'purple' | 'gold';
};
export function CTAButton({
  children,
  href = CHECKOUT_URL,
  className = '',
  fullWidth = false,
  variant = 'purple'
}: CTAButtonProps) {
  const colors = variant === 'gold' ? 'bg-brand-gold text-brand-navy hover:bg-brand-goldDark hover:text-white' : 'bg-brand-green text-white hover:bg-brand-greenDark';
  return <motion.a href="#pricing" whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`inline-flex items-center justify-center rounded-full px-8 py-4 text-lg font-bold shadow-[0_10px_24px_rgba(16,44,29,.18)] transition-colors focus:outline-none focus-visible:ring-4 focus-visible:ring-brand-gold/40 ${colors} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-277" data-mp="2lsc24gjkabn3">
      {children}
    </motion.a>;
}